import { render, staticRenderFns } from "./AddGroupDashboardBudget.vue?vue&type=template&id=0db28e16&"
import script from "./AddGroupDashboardBudget.vue?vue&type=script&lang=js&"
export * from "./AddGroupDashboardBudget.vue?vue&type=script&lang=js&"
import style0 from "./AddGroupDashboardBudget.vue?vue&type=style&index=0&id=0db28e16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports